import React from "react";
import classNames from "classnames";
import { TeaserLinkParams } from "./TeaserLinkParams.csharp";

const imageWidth = 288;
const imageAnchor = "Center";

export const TeaserLink: React.FC<TeaserLinkParams> = ({
  label,
  link,
  imageUrl,
  themeColorValues,
  customThemeColorInHex,
}) => {
  const labelSpan = () => {
    return (
      <span
        dangerouslySetInnerHTML={{
          __html: label.replace(/\|/g, "&shy;"),
        }}
      />
    );
  };

  return (
    <div className="edge-to-edge-sm card__column-alternation-xl col-xl-9 mb-1">
      <div
        className={classNames("card", themeColorValues.contrastColor, {
          "card-hover": link,
        })}
        style={
          customThemeColorInHex
            ? { backgroundColor: customThemeColorInHex }
            : undefined
        }
      >
        <div className="d-flex">
          <div className="card-inner-square position-relative">
            {imageUrl && (
              <img
                src={
                  imageUrl +
                  `?width=${imageWidth}&ranchor=${imageAnchor}`
                }
                alt={label}
                loading="lazy"
              />
            )}
          </div>
          <div className="card-inner-square">
            <div className="card-inner-square__padding">
              <p className="h5 card-title mb-0">
                {link ? (
                  <a className="card-block-link" href={link}>
                    {labelSpan()}
                    <i className="icon icon-arrow-right" />
                  </a>
                ) : (
                  labelSpan()
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
